var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._g(_vm._b({attrs:{"href":`tel:${_vm.hrefNumber}`,"aria-label":_vm.ariaLabel},domProps:{"innerHTML":_vm._s(_vm.displayNumber)},on:{"click":_vm.makePhoneCall}},'a',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }